import {currencyFormatter} from "../../../utils/format";

interface Props {
    label: string|any,
    value: string|any,
    isCurrency?: boolean,
    className?: string,
    isCustomValue?: boolean
}

const AmountItem = ({ label, value, isCurrency = true, className = '', isCustomValue = false } : Props) => {
    return (
        <div className={`flex justify-between ${className}`}>
            <span>{ label }</span>
            {
                isCustomValue ? (
                    <span>{ value }{ isCurrency}</span>
                ) : (
                    <span>
                        {
                            isCurrency ? currencyFormatter.format(value) : value
                        }
                    </span>
                )
            }

        </div>
    )
}

export default AmountItem;
